import { createFileRoute, redirect } from '@tanstack/react-router';

// Deep-link redirect: stale /settings/analytics/$codebaseId bookmarks land on
// the new top-level analytics route's overview tab for the same codebase.
export const Route = createFileRoute('/$organizationName/settings/analytics/$codebaseId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/analytics/$codebaseId/$tab',
      params: { organizationName: params.organizationName, codebaseId: params.codebaseId, tab: 'overview' },
    });
  },
});
